export default class BaromoneyTransferSetting {
    _id = '';
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    /** 차감 대상 */
    _sourceName = '';
    get sourceName() {
        return this._sourceName;
    }
    set sourceName(value) {
        this._sourceName = value;
    }
    /** 바로머니 이동 차감 대상 타입 */
    _sourceType = '';
    get sourceType() {
        return this._sourceType;
    }
    set sourceType(value) {
        this._sourceType = value;
    }
    /** 차감 코드 */
    _sourceCode = '';
    get sourceCode() {
        return this._sourceCode;
    }
    set sourceCode(value) {
        this._sourceCode = value;
    }
    /** 이체 대상 */
    _targetName = '';
    get targetName() {
        return this._targetName;
    }
    set targetName(value) {
        this._targetName = value;
    }
    /** 차감자 ID */
    _movedBy = '';
    get movedBy() {
        return this._movedBy;
    }
    set movedBy(value) {
        this._movedBy = value;
    }
    /** 차감액 정액 */
    _moveFix = 0;
    get moveFix() {
        return this._moveFix;
    }
    set moveFix(value) {
        this._moveFix = value;
    }
    /** 차감액 정률 구분 타입 */
    _moveRateType = '';
    get moveRateType() {
        return this._moveRateType;
    }
    set moveRateType(value) {
        this._moveRateType = value;
    }
    /** 차감액 정률 */
    _moveRate = 0;
    get moveRate() {
        return this._moveRate;
    }
    set moveRate(value) {
        this._moveRate = value;
    }
    /** 차감주기 / 0: 매일, 35: 매월 말일, N: 매월 N일 */
    _movePeriodDay = 0;
    get movePeriodDay() {
        return this._movePeriodDay;
    }
    set movePeriodDay(value) {
        this._movePeriodDay = value;
    }
    /** 삭제 여부 */
    _isDeleted = false;
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(value) {
        this._isDeleted = value;
    }
    /** 바로머니 이동 서비스 타입 */
    _serviceType = '';
    get serviceType() {
        return this._serviceType;
    }
    set serviceType(value) {
        this._serviceType = value;
    }
    /** 차감 대상 메모 */
    _status = '';
    get status() {
        return this._status;
    }
    set status(value) {
        this._status = value;
    }
    /** 등록 일자 */
    _createdAt = '';
    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }
    /** 등록자 ID */
    _createdBy = '';
    get createdBy() {
        return this._createdBy;
    }
    set createdBy(value) {
        this._createdBy = value;
    }
    /** 수정자 ID */
    _updatedAt = '';
    get updatedAt() {
        return this._updatedAt;
    }
    set updatedAt(value) {
        this._updatedAt = value;
    }
    /** 수정 일자 */
    _updatedBy = '';
    get updatedBy() {
        return this._updatedBy;
    }
    set updatedBy(value) {
        this._updatedBy = value;
    }
    /** 적용 시작 날짜 */
    _applyDate = '';
    get applyDate() {
        return this._applyDate;
    }
    set applyDate(value) {
        this._applyDate = value;
    }
    /** 적용 종료 날짜 */
    _expireDate = '';
    get expireDate() {
        return this._expireDate;
    }
    set expireDate(value) {
        this._expireDate = value;
    }
    /** 차감 메모 */
    _moveMemo = '';
    get moveMemo() {
        return this._moveMemo;
    }
    set moveMemo(value) {
        this._moveMemo = value;
    }
    /** 바로머니 이동 이동 대상 타입 */
    _targetType = '';
    get targetType() {
        return this._targetType;
    }
    set targetType(value) {
        this._targetType = value;
    }
    /** 이동대상 코드 */
    _targetCode = '';
    get targetCode() {
        return this._targetCode;
    }
    set targetCode(value) {
        this._targetCode = value;
    }
    constructor(_data) {
        if (!_data) {
            return;
        }
        const data = this.translate(_data);
        Object.assign(this, data);
    }
    /**
     * 서버 응답값을 프론트에서 사용할 형태로 번역
     * back -> front
     * @returns
     */
    // eslint-disable-next-line class-methods-use-this
    translate(data) {
        return {
            ...data,
        };
    }
}
